import { useSelector } from "react-redux";
import { adminAPI } from "../api/adminAPI";
import { AlertBox } from "../ui";

const ShowErrors = ({ data, status }) => {
  if (status === 200) return;
  const errors = data.message
    ? [data.message]
    : data.errors.map((err) => err.msg);
  AlertBox({ color: "error", messages: errors });
};

export const useAPI = () => {
  const { jwt } = useSelector((state) => state.auth);
  const headers = {
    "x-token": jwt,
    "Cache-Control": "no-cache",
  };

  const get = async (endpoint) => {
    try {
      const { data, status } = await adminAPI.get(endpoint, { headers });
      return { data, status, isSuccess: true };
    } catch (error) {
      ShowErrors(error.response);
      return { isSuccess: false };
    }
  };

  const post = async (endpoint, dataForm) => {
    try {
      const { data, status } = await adminAPI.post(endpoint, dataForm, {
        headers,
      });
      const { message } = data;
      AlertBox({ color: "success", messages: [message] });
      return { data, status, isSuccess: true };
    } catch (error) {
      ShowErrors(error.response);
      return { isSuccess: false };
    }
  };
  const del = async (endpoint) => {
    try {
      const { data, status } = await adminAPI.delete(endpoint, { headers });
      const { message } = data;
      AlertBox({ color: "success", messages: [message] });
      return { data, status, isSuccess: true };
    } catch (error) {
      ShowErrors(error.response);
      return { isSuccess: false };
    }
  };
  const patch = async (endpoint, dataForm) => {
    try {
      const { data, status } = await adminAPI.patch(endpoint, dataForm, {
        headers,
      });
      const { message } = data;
      AlertBox({ color: "success", messages: [message] });
      return { data, status, isSuccess: true };
    } catch (error) {
      console.log(error);
      ShowErrors(error.response);
      return { isSuccess: false };
    }
  };

  return { get, post, del, patch };
};
